export var Currencies = ["$ BSD", "€ EUR", "R ZAR"];
export var currencyFromCountry = function (c) {
    switch (c) {
        case "ZA": return "R ZAR";
        case "BS": return "$ BSD";
        default: return "€ EUR";
    }
};
var Money = /** @class */ (function () {
    function Money(amount, currency) {
        this.amount = amount;
        this.currency = currency;
    }
    Money.times = function (that, amount) {
        return new Money(that.amount * amount, that.currency);
    };
    Money.minus = function (that, those) {
        if (that.currency !== those.currency) {
            throw new Error("Both Money values need to have the same currency!");
        }
        return new Money(that.amount - those.amount, that.currency);
    };
    return Money;
}());
export { Money };



//////////////////
// WEBPACK FOOTER
// ./src/data/Money.ts
// module id = 197
// module chunks = 0